import {makeAutoObservable} from 'mobx';
import {
    IStatByDate,
    IStatsSummary,
    ITransactionsByDate,
    IUsersStatsByDate,
    IVolumeByDate
} from '../services/api/api.interfaces';
import apiService from '../services/api/api.service';

const filterOnlyPastStats = (stats: IStatByDate[]): any[] => {
    return stats.filter(stat => new Date(stat.date) <= new Date());
}

export class StatsStore {
    usersStats: IUsersStatsByDate[] = [];
    volumeStats: IVolumeByDate[] = [];
    transactionsStats: ITransactionsByDate[] = [];
    summary: IStatsSummary | null = null;

    get userStatsForChart() {
        return this.usersStats.map(stat => ({
            time: stat.date,
            value: Number(stat.count),
        }));
    }

    get volumeStatsForChart() {
        return this.volumeStats.map(stat => ({
            time: stat.date,
            value: Number(stat.volume)
        }));
    }

    get transactionStatsForChart() {
        return this.transactionsStats.map(stat => ({
            time: stat.date,
            value: Number(stat.total),
        }));
    }

    constructor() {
        makeAutoObservable(this);
    }

    setSummary = (summary: IStatsSummary) => {
        this.summary = summary;
    }

    setUsersStats = (stats: IUsersStatsByDate[]) => {
        this.usersStats = filterOnlyPastStats(stats);
    };

    setTransactionStats = (stats: ITransactionsByDate[]) => {
        this.transactionsStats = filterOnlyPastStats(stats);
    };

    setVolumeStats = (stats: IVolumeByDate[]) => {
        this.volumeStats = filterOnlyPastStats(stats);
    };

    async fetchUsersStats() {
        try {
            const usersStats = await apiService.usersStatsGet();
            this.setUsersStats(usersStats);
            return usersStats;
        } catch (err) {
            console.error('Failed to fetch markets:', err);
        }
    };

    async fetchTxsStats() {
        try {
            const stats = await apiService.txsStatsGet();
            this.setTransactionStats(stats);
            return stats;
        } catch (err) {
            console.error('Failed to fetch markets:', err);
        }
    };

    async fetchVolumeStats() {
        try {
            const stats = await apiService.volumeStatsGet();
            this.setVolumeStats(stats);
            return stats;
        } catch (err) {
            console.error('Failed to fetch markets:', err);
        }
    };
    async fetchSummaryStats() {
        try {
            const stats = await apiService.statsSummaryGet();
            this.setSummary(stats);
            return stats;
        } catch (err) {
            console.error('Failed to fetch markets:', err);
        }
    }
}

export const statsStore = new StatsStore();
